import React, { useMemo } from "react";
import { Link } from "react-router-dom";
import { GAMES } from "../services/mockData";

// แบนเนอร์หัวหน้าเพจ + breadcrumb (พื้นหลังเป็นคอลลาจรูปเกม)
export default function PageBanner({ title, breadcrumb = [], seed = 0 }) {
  const tiles = useMemo(
    () => Array.from({ length: 16 }).map((_, index) => GAMES[(index * 3 + seed) % GAMES.length].image),
    [seed]
  );

  return (
    <div className="lt-banner">
      <div className="lt-banner__tiles" aria-hidden="true">
        {tiles.map((src, index) => (
          <img key={index} src={src} alt="" />
        ))}
      </div>
      <div className="lt-banner__content">
        <h1 className="lt-banner__title">{title}</h1>
        <div className="lt-breadcrumb">
          <Link to="/">หน้าหลัก</Link>
          {breadcrumb.map((item, index) => (
            <React.Fragment key={index}>
              <span className="sep">›</span>
              {item.to ? <Link to={item.to}>{item.label}</Link> : <span className="is-current">{item.label}</span>}
            </React.Fragment>
          ))}
        </div>
      </div>
    </div>
  );
}
